import React from 'react';
import { fieldPropTypes } from 'redux-form';
import { PhoneSimpleField } from 'components/FormFieldsSimple/PhoneSimpleField';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class PhoneField extends React.PureComponent {
  static propTypes = {
    ...fieldPropTypes,
  };

  static defaultProps = {};

  handleChange = (value) => {
    const { input } = this.props;
    value !== '' && input.onChange(value);
  };

  render() {
    const { input, testId } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <PhoneSimpleField
          onFocus={input.onFocus}
          onBlur={input.onBlur}
          {...this.props}
          onChange={this.handleChange}
          value={input.value}
          testId={testId}
        />
      </ReduxFormElementWrapper>
    );
  }
}
